import React, { useEffect } from "react";

import Loading from "../../component/Loading";
import AddGroup from "./AddGroup";
import { TAKS_IMPORT } from "../../config/lang";

import { call } from "../../util/action";
import CreateMsgPopup from "../../util/CreateMsgPopup";
import { getStore } from "../../util/redux/store";
import { translate } from "../../util/util";

const me = getStore().getState().me;
function Grouping({ isActive = false, handleGroupPopup, checkedRowsIds = [], getCurrentGroupData, filterUrlKeys, onAllPointsAdded, clearPointsTrigger }) {
  const [state, setState] = React.useState({ points: [], loading: false });
  const [group, setGroup] = React.useState({ activeGroup: {}, loading: false });
  const [selectedGroupType, setSelectedGroupType] = React.useState({ type: "list" });
  const [isMsgStatus, setIsMsgStatus] = React.useState({ status: false, type: "error", message: "" });

  useEffect(() => {
    if (!isActive) return;
    let isMounted = true;

    getPointGroupList(isMounted);
    return () => {
      isMounted = false;
    };
  }, [isActive]);

  useEffect(() => {
    setGroup(prev => ({
      ...prev,
      activeGroup: { ...prev.activeGroup, points: checkedRowsIds },
    }));
  }, [checkedRowsIds]);

  useEffect(() => {
    if (selectedGroupType.type === "clone") {
      setSelectedGroupType({ type: "new" });
      getCurrentGroupData("new", group.activeGroup.points);
    }
  }, [group.activeGroup]);

  const userValidation = createdBy => {
    return me.id === createdBy || me.role === "supervisor_manager" ? true : false;
  };

  const getPointGroupList = (isMounted = true) => {
    setState(prev => ({ ...prev, loading: true }));
    // active=true so a deleted (soft-deleted) group drops out of this popup immediately.
    // Deactivated groups remain visible on the /point_groups admin list for reactivation.
    call({ method: "GET", url: "point_groups/?active=true" }, response => {
      if (!isMounted) return;
      setState(prev => ({
        ...prev,
        points: response.results,
        loading: false,
      }));
    });
  };

  const fetchPointGroupById = (id, method, options) => {
    if (!id && !method) {
      throw new Error("id or type is required");
    }

    //check user access
    if ((method === "DELETE" && !userValidation(options.author_id)) || (!userValidation(options.author_id) && options.type === "edit")) {

      setIsMsgStatus({
        status: true,
        type: "error",
        message: translate(TAKS_IMPORT, "new_group_popup_user_validate_error_text", me.language),
      });
      return;
    }

    if (method === "GET") setGroup(prev => ({ ...prev, loading: true }));

    // end check user access
    if (method === "GET") setGroup(prev => ({ ...prev, loading: true }));

    call({ method: method, url: "point_groups/" + id + "/" }, response => {
      if (method === "GET") {
        const type = options?.operation && options?.operation === "clone" ? "clone" : "edit";

        setGroup(prev => ({
          ...prev,
          activeGroup: {
            ...response,
            name: `${response.name}${type === "clone" ? " (clone)" : ""}`,
          },
          loading: false,
        }));

        setSelectedGroupType({ type });

        if (response.points && type === "edit") {
          getCurrentGroupData("edit", response.points);
        } else if (response.points && type === "clone") {
          getCurrentGroupData("new", response.points);
        }
      } else if (method === "DELETE") {
        if (response.status === 204) {
          setSelectedGroupType({ type: "list" });
          getPointGroupList();
          setIsMsgStatus({
            status: true,
            type: "success",
            message: translate(TAKS_IMPORT, "new_group_popup_success_deleted_text", me.language),
          });
        } else {
          setIsMsgStatus({
            status: true,
            type: "error",
            message: translate(TAKS_IMPORT, "new_group_popup_failed_deleted_text", me.language),
          });
          throw new Error("Response is not 204", response);
        }
      }
    });
  };

  const handleEdit = (id, created_by) => {
    fetchPointGroupById(id, "GET", { author_id: created_by, type: "edit" });
  };

  const handleCopy = id => {
    fetchPointGroupById(id, "GET", { operation: "clone" });
  };

  const handleDelete = (id, created_by) => {
    const confirmed = window.confirm(translate(TAKS_IMPORT, "new_group_popup_delete_approve_text", me.language));

    if (confirmed) {
      fetchPointGroupById(id, "DELETE", { author_id: created_by });
    }
  };

  const handleNewGroup = () => {
    setSelectedGroupType({ type: "new" });
    getCurrentGroupData("new", []);

    setGroup({ activeGroup: {}, loading: false });
  };

  const handleBackToGroupList = () => {
    setSelectedGroupType({ type: "list" });
    getCurrentGroupData("list", []);
    getPointGroupList();
  };
  const handleClose = () => {
    handleGroupPopup(false);
    handleBackToGroupList();
  };

  return (
    <>
      {isMsgStatus.status && <CreateMsgPopup setIsMsg={setIsMsgStatus} isMsg={isMsgStatus} />}
      <div className={`grouping-popup-wrapper ${isActive ? "active" : ""}`}>
        <button className="gp-close-btn" onClick={handleClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
        <div className={`gp-header ${selectedGroupType.type !== "list" ? "gp-header--inner" : ""}`}>
          {selectedGroupType.type !== "list" && (
            <button className="gp-back-btn" onClick={handleBackToGroupList}>
              <span className="material-symbols-outlined">arrow_back</span>
            </button>
          )}
          <h3 className="gp-title">
            {selectedGroupType.type === "new"
              ? translate(TAKS_IMPORT, "new_group_popup_new_title", me.language)
              : selectedGroupType.type === "edit"
              ? translate(TAKS_IMPORT, "new_group_popup_edit_title", me.language)
              : selectedGroupType.type === "list"
              ? translate(TAKS_IMPORT, "grouping_popup_title", me.language)
              : "Undefined Status"}
          </h3>
          {selectedGroupType.type === "list" && (
            <button className="gp-new-btn" onClick={handleNewGroup}>
              <span className="material-symbols-outlined">add</span>
              {translate(TAKS_IMPORT, "new_group_btn_name", me.language)}
            </button>
          )}
        </div>
        <div className="gp-content-scroll">
          <div className="gp-content">
            {state.loading || group.loading ? (
              <Loading loading={state.loading || group.loading} />
            ) : (
              <>
                {selectedGroupType.type === "list" && (
                  <div className="gp-list">
                    {state.points?.map(point => (
                      <div className="gp-item" key={point.id}>
                        <div className="gp-item-info">
                          <span className="gp-item-id">#{point.id}</span>
                          <span className="gp-item-name">{point.name}</span>
                        </div>
                        <div className="gp-item-actions">
                          <button className="gp-item-btn gp-item-btn--edit" onClick={() => handleEdit(point.id, point.created_by?.id)} title="Edit">
                            <span className="material-symbols-outlined">edit</span>
                          </button>
                          <button className="gp-item-btn gp-item-btn--copy" onClick={() => handleCopy(point.id)} title="Clone">
                            <span className="material-symbols-outlined">content_copy</span>
                          </button>
                          <button className="gp-item-btn gp-item-btn--delete" onClick={() => handleDelete(point.id, point.created_by?.id)} title="Delete">
                            <span className="material-symbols-outlined">delete</span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {selectedGroupType.type !== "list" && (
                  <AddGroup
                    backToGroupList={handleBackToGroupList}
                    type={selectedGroupType.type}
                    group={group.activeGroup}
                    updateCheckboxIds={getCurrentGroupData}
                    filterUrlKeys={filterUrlKeys}
                    onAllPointsAdded={onAllPointsAdded}
                    clearPointsTrigger={clearPointsTrigger}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Grouping;
